export class DeliveryFeedBack {

    feedbackDate: string;
    assignedNo: string;
    feedbackFor: string;
    feedbackBy: string;
    toLocation: number;
    toDeliveryBoy: number;
    toCustomer: number;
    locationCode: number;
    servicemanCode: number;
    customerCode: number;

}
